<template>
  <ModalPopUp class="email-modal" :modalActive="modalActive" @closeBackgroundModal="emitCloseModal" :allowClose="apiStatus.loading === false">
    <template #modalContent>
      <div class="success-tick" v-if="apiStatus.success && !apiStatus.fail && !apiStatus.loading">
        <img src="/assets/public/images/icon_tick.svg" alt="tick icon" />
      </div>

      <div class="modal-header">
        <h2>{{ apiStatus.success ? 'Quote emailed successfully' : 'Email me this quote' }}</h2>
        <hr />
      </div>

      <div class="modal-body">
        <!-- Quote email sending in progress -->
        <template v-if="apiStatus.loading">
          <ApiLoading loadingMessage="Sending this quote to your email." :apiError="apiStatus.fail" :isMemberPortal="true" :loadingTitle="null" />
        </template>

        <!-- Invalid email address -->
        <template v-else-if="apiStatus.isInvalidEmail">
          <Alert
            alertType="error"
            message="There is no valid email saved on your policy.<br><br> Please provide a valid email address below which will be used to send your quote and saved for all policy related communications."
            :isPlainText="false"
          />

          <FormField
            labelText="My email address"
            v-model="v$.newEmail.$model"
            placeholder="Enter your email address"
            :error="v$.newEmail.$error"
            :errorMessage="`Please enter a valid email address.`"
          />

          <button @click.prevent="emailQuoteHook" :disabled="v$.$invalid">Send and update</button>
        </template>

        <!-- Quote email sending failed -->
        <template v-else-if="apiStatus.fail">
          <Alert alertType="error">
            <!-- prettier-ignore -->
            <p>Email could not be sent. Please try again or <router-link :to="{ name: CONTACT_US }">contact us</router-link>. Our friendly team will be happy to help you.</p>
          </Alert>
          <a class="button secondary" @click.prevent="emitCloseModal">Close</a>
        </template>

        <!-- Quote email sent successfully -->
        <template v-else-if="apiStatus.success">
          <p v-if="emailSentTo">
            We’ve sent this quote to
            <!-- prettier-ignore -->
            <span><a>{{ emailSentTo }}</a>,</span>
            the email saved on your policy.
          </p>
          <p>
            You can update your email address in
            <!-- prettier-ignore -->
            <span><a id="memberDetails">member details</a>.</span>
          </p>
          <a class="button secondary" @click.prevent="emitCloseModal">Close</a>
        </template>
      </div>
    </template>
  </ModalPopUp>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { requiredIf, email } from '@vuelidate/validators';
import { ApiLoading, Alert, FormField, ModalPopUp } from '@/components';
import { CONTACT_US } from '@/router/routeNames';

export default {
  setup() { return { v$: useVuelidate() }; },

  name: 'EmailQuoteModal',
  emits: ['emailQuoteHook', 'closeModal'],
  components: {
    ApiLoading,
    Alert,
    FormField,
    ModalPopUp,
  },
  props: {
    modalActive: {
      type: Boolean,
      required: true,
    },
    apiStatus: {
      type: Object,
      required: true,
    },
    emailSentTo: {
      type: String,
      required: false,
    },
  },

  data() {
    return {
      newEmail: null,
      CONTACT_US,
    };
  },

  validations() {
    return {
      newEmail: {
        required: requiredIf(() => {
          return this.apiStatus.isInvalidEmail;
        }),
        email,
      },
    };
  },

  methods: {
    emailQuoteHook() {
      this.$emit('emailQuoteHook', this.newEmail);
    },

    emitCloseModal() {
      this.newEmail = null; // clear entered email when modal is closed, otherwise previous email will be shown when modal is opened again
      this.v$.$reset(); // reset vuelidate validations
      this.$emit('closeModal');
    },
  },
};
</script>
